// Scribe caps a list page at 200; one page covers every patient we expect.
export const CONSULTATIONS_LIST_LIMIT = 200;

// How often a list or an encounter is read again while it is processed.
export const ENCOUNTER_POLLING_INTERVAL_MS = 5000;

// The start page names the template card it starts: a template series, or an
// encounter schema that has no note of its own.
export const RECORDING_START_SERIES_PARAM = 'series';
export const RECORDING_START_SCHEMA_PARAM = 'schema';

export enum CONSULTATION_TYPE {
  Dental = 'dental',
  Pediatric = 'pediatric',
  Medical = 'medical',
  CoordinatorNewPatient = 'coordinator_new_patient',
  CoordinatorFollowUp = 'coordinator_follow_up',
  Soap = 'soap',
}

export enum TRANSCRIPTOR_LANGUAGE {
  English = 'en',
  German = 'de',
  Spanish = 'es',
  French = 'fr',
  Hebrew = 'he',
  Hungarian = 'hu',
  Italian = 'it',
  Georgian = 'ka',
  Kazakh = 'kk',
  Polish = 'pl',
  Portuguese = 'pt',
  Romanian = 'ro',
  Russian = 'ru',
  Ukrainian = 'uk',
}

// Every platform language is a content language: scribe accepts any of
// these codes for specialties, templates and recordings.
export const SUPPORTED_CONTENT_LANGUAGES = Object.values(TRANSCRIPTOR_LANGUAGE);

export const API_STATUS_MAP = {
  unknown: 'unknown',
  in_progress: 'in_progress',
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

export const PROCESSING_PROGRESS_MAP = {
  unknown: 0,
  in_progress: 50,
  succeeded: 100,
  failed: 0,
  default: 0,
} as const;

export const OBJECT_ID_LENGTH = 24;

// Wire contract with scribe: the skip reason scribe records on every document
// (and mirrors on the encounter) when a recording has no detectable speech.
// Keep in sync with model.NoSpeechDetectedError in services/scribe.
export const NO_SPEECH_DETECTED_ERROR = 'no speech detected in recording';

// Wire contract with scribe: the error scribe records on an encounter whose
// audio upload was never completed.
// Keep in sync with model.UploadNotCompletedError in services/scribe.
export const UPLOAD_NOT_COMPLETED_ERROR = 'upload was not completed';

export const NANOSECONDS_PER_SECOND = 1_000_000_000;

export const RECORDING_EVENT_PREFIX = 'transcriptor_recording_';

export const AUDIO_CONFIG = {
  SAMPLE_RATE: 16000,
  CHUNK_DURATION_MS: 30000, // 30 seconds
  MAX_FILE_SIZE_MB: 100,
  SUPPORTED_FORMATS: [
    'audio/webm',
    'audio/mp4',
    'audio/wav',
    'audio/mpeg',
    'audio/ogg',
    'video/webm',
  ],
  SUPPORTED_MIME_TYPES: [
    'audio/webm',
    'audio/mp4',
    'audio/wav',
    'audio/mpeg',
    'audio/ogg',
    'video/webm',
    'audio/m4a',
    'audio/x-m4a',
  ],
  DEFAULT_MIME_TYPE: 'audio/webm',
} as const;
